module.exports = __webpack_public_path__ + "img/02-1数字化生产.ccfc7001.png";